(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ruts-combina-bien-con"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.rutsCbcBound) return;
    window.rutsCbcBound = true;

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-ruts-cbc-form]');
      if (!form) return;
      event.preventDefault();

      var btn = form.querySelector('[data-ruts-cbc-add]');
      if (!btn || btn.disabled) return;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Añadiendo…';

      fetch(form.action, {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          btn.textContent = 'Añadido ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          var drawer = document.querySelector('cart-drawer, [ref="cartDrawer"]');
          if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = original;
          form.submit();
        });
    });

    function setup(track) {
      var vp = track.closest('.ruts-cbc__viewport');
      if (!vp) return;
      var prev = vp.querySelector('[data-ruts-cbc-prev]');
      var next = vp.querySelector('[data-ruts-cbc-next]');

      function step() {
        var c = track.querySelector('.ruts-cbc__card');
        return c ? (c.getBoundingClientRect().width + 12) * 2 : 340;
      }
      function update() {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        var overflow = track.scrollWidth > track.clientWidth + 4;
        if (prev) prev.hidden = !overflow || track.scrollLeft <= 2;
        if (next) next.hidden = !overflow || track.scrollLeft >= maxScroll;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function init() {
      document.querySelectorAll('[data-ruts-cbc-track]').forEach(setup);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ruts-mobile-pdp-order"] && !Shopify.designMode) return;
  try {
    (function () {
    var MQ = window.matchMedia('(max-width: 749px)');

    var media = null;
    var parentOriginal = null;
    var nextSiblingOriginal = null;

    function reorder() {
      if (window.Shopify && window.Shopify.designMode) return;

      var anchor = document.querySelector('[data-ruts-mobile-order-anchor]');
      if (!anchor) return;

      var grid = document.querySelector('[data-product-grid-content]');
      if (!grid) return;

      if (anchor.parentNode.firstElementChild !== anchor) {
        anchor.parentNode.insertBefore(anchor, anchor.parentNode.firstElementChild);
      }

      if (!media) {
        media = grid.querySelector('.product-information__media');
        if (!media) return;
        parentOriginal = media.parentNode;
        nextSiblingOriginal = media.nextSibling;
      }

      if (MQ.matches) {
        if (anchor.previousElementSibling !== media) {
          anchor.parentNode.insertBefore(media, anchor);
        }
      } else {
        if (media.parentNode !== parentOriginal || media.nextSibling !== nextSiblingOriginal) {
          parentOriginal.insertBefore(media, nextSiblingOriginal);
        }
      }
    }

    function init() {
      reorder();
      if (MQ.addEventListener) {
        MQ.addEventListener('change', reorder);
      } else if (MQ.addListener) {
        MQ.addListener(reorder);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
